import { MutationTree } from 'vuex';
import { SnackbarState, InternalSnack } from '../types';

export const snackbarMutations: MutationTree<SnackbarState> = {

  clear(state) {
    state.snackQueue = [];
  },

  addSnack(state, snack: InternalSnack) {
    state.snackQueue.push(snack);
  },

  // This function could be triggered multiple times (time out and click on close) for the same snack
  removeSnack(state, snack: InternalSnack) {
    state.snackQueue = state.snackQueue.filter((currentSnack) => currentSnack.id !== snack.id);
  },

};
